module.exports = __webpack_public_path__ + "img/wm2.d2a2663f.png";